import React, { useEffect, useState, useCallback } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './superagentes.css';
import { Link } from 'react-router-dom';
import { carouselInicio } from '../../json/carousel';

// Data for agents
const agents = [
  {
    id: 1,
    name: "Capitán Justicia",
    role: "Líder del Escuadrón",
    power: "Verdad Absoluta",
    colorClass: "agent-blue",
    image: "/videos/fotos-agentes/01.JPG"
  },
  {
    id: 2,
    name: "Agente Cívica",
    role: "Defensora Urbana",
    power: "Súper Respeto",
    colorClass: "agent-red",
    image: "/videos/fotos-agentes/02.png"
  },
  {
    id: 3,
    name: "Doctor Honestidad",
    role: "Estratega",
    power: "Rayo de Luz",
    colorClass: "agent-yellow",
    image: "/videos/fotos-agentes/03.png"
  }
];

// Hero Carousel slides
const heroSlides = [
  {
    image: "/videos/fotos-agentes/04.jpg",
    title: "¡Protege tu ciudad!",
    subtitle: "La honestidad es tu superpoder."
  },
  {
    image: "/videos/fotos-agentes/05.jpg",
    title: "¡Ayuda a los demás!",
    subtitle: "Un verdadero héroe siempre es amable."
  },
  {
    image: "/videos/fotos-agentes/06.jpeg",
    title: "¡Conoce las reglas!",
    subtitle: "El saber es nuestra mejor arma."
  },
  {
    image: "/videos/fotos-agentes/12.jpg",
    title: "¡Sé un líder!",
    subtitle: "El liderazgo transforma comunidades."
  },
  {
    image: "/videos/fotos-agentes/14.jpg",
    title: "¡Trabaja en equipo!",
    subtitle: "La unión hace la fuerza."
  },
  {
    image: "/videos/fotos-agentes/16.JPG",
    title: "¡Actúa con justicia!",
    subtitle: "La justicia es nuestra guía."
  },
  {
    image: "/videos/fotos-agentes/13.jpg",
    title: "¡Respeta a todos!",
    subtitle: "El respeto construye puentes."
  },
  {
    image: "/videos/fotos-agentes/15.jpg",
    title: "¡Cuida tu entorno!",
    subtitle: "El planeta necesita héroes."
  },
  {
    image: "/videos/fotos-agentes/17.JPG",
    title: "¡Sé creativo!",
    subtitle: "La creatividad resuelve problemas."
  },
  {
    image: "/videos/fotos-agentes/18.jpg",
    title: "¡Inspira a otros!",
    subtitle: "Tu ejemplo cambia el mundo."
  }
];

// Hero videos
const teamVideos = [
  {
    src: "/videos/fotos-agentes/Susy_Diego_47.mp4",
    title: "Conoce a los Súper Agentes"
  },
  {
    src: "/videos/fotos-agentes/Eco_48.mp4",
    title: "Nuestra Misión"
  },
  {
    src: "/videos/fotos-agentes/Lupo_48.mp4",
    title: "Actividades"
  },
  {
    src: "/videos/fotos-agentes/SH_SR_47.mp4",
    title: "Actividades"
  }
];

// Dibujo images for gallery
const dibujoImages = [
  // { id: 9, src: "/assets/imgs/dibujos/integrantes.jpeg", alt: "Dibujo 9" },
  { id: 1, src: "/assets/imgs/dibujos/honesta.jpeg", alt: "Dibujo 1" },
  { id: 2, src: "/assets/imgs/dibujos/responsable.jpeg", alt: "Dibujo 2" },
  { id: 3, src: "/assets/imgs/dibujos/eco.jpeg", alt: "Dibujo 3" },
  { id: 4, src: "/assets/imgs/dibujos/lupo.jpeg", alt: "Dibujo 4" },
  { id: 5, src: "/assets/imgs/dibujos/diego.jpeg", alt: "Dibujo 5" },
  { id: 6, src: "/assets/imgs/dibujos/rosita.jpeg", alt: "Dibujo 6" },
  { id: 7, src: "/assets/imgs/dibujos/pepe.jpeg", alt: "Dibujo 7" },
  { id: 8, src: "/assets/imgs/dibujos/susy.jpeg", alt: "Dibujo 8" }
];

// Character images for gallery
const characterImages = [
  


  { id: 1, src: "/videos/fotos-agentes/personajes/honesta.jpeg", alt: "Personaje 1" },
  { id: 2, src: "/videos/fotos-agentes/personajes/responsabilidad.jpeg", alt: "Personaje 2" },
  { id: 3, src: "/videos/fotos-agentes/personajes/ambiente.jpeg", alt: "Personaje 3" },
  { id: 4, src: "/videos/fotos-agentes/personajes/igualdad.jpeg", alt: "Personaje 4" },
  { id: 5, src: "/videos/fotos-agentes/juegos/cruci.png", alt: "Personaje 5" },
  { id: 6, src: "/videos/fotos-agentes/juegos/letras.png", alt: "Personaje 6" },
  { id: 7, src: "/videos/fotos-agentes/juegos/gato.jpeg", alt: "Personaje 7" },
  { id: 8, src: "/videos/fotos-agentes/juegos/valores.png ", alt: "Personaje 8" },
  { id: 9, src: "/videos/fotos-agentes/juegos/rompecabezas.jpeg", alt: "Personaje 9" },
  

  

];

// Downloads data
const downloads = [
  {
    id: 1,
    title: "Recorta tu Placa",
    description: "Imprime y recorta tu propia placa oficial de Súper Agente.",
    icon: "fa-scissors",
    colorClass: "download-red"
  },
  {
    id: 2,
    title: "Colorea al Equipo",
    description: "Dale vida a tus héroes favoritos con tus colores.",
    icon: "fa-pen",
    colorClass: "download-yellow"
  },
  {
    id: 3,
    title: "Sopa de Letras",
    description: "Encuentra las palabras secretas de la legalidad.",
    icon: "fa-question",
    colorClass: "download-blue"
  }
];

// Agent Card Component
const AgentCard = ({ agent }) => {
  return (
    <div className="agent-card-wrapper">
      <div className={`agent-card-bg ${agent.colorClass}`}></div>
      <div className="agent-card">
        <div className="agent-image-container">
          <img src={agent.image} alt={agent.name} className="agent-image" />
        </div>
        <div className="agent-info">
          <h3 className="agent-name">{agent.name}</h3>
          <span className="agent-role">{agent.role.toUpperCase()}</span>
          <div className="agent-power">
            <i className="fa-solid fa-bolt"></i>
            <span>{agent.power}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

// Download Card Component
const DownloadCard = ({ item }) => {
  return (
    <div className="download-card">
      <div className={`download-icon-container ${item.colorClass}`}>
        <i className={`fa-solid ${item.icon}`}></i>
      </div>
      <h3 className="download-title">{item.title}</h3>
      <p className="download-description">{item.description}</p>
      <button className="btn-comic btn-comic-accent">
        <i className="fa-solid fa-download me-2"></i>
        Descargar PDF
      </button>
    </div>
  );
};

// Image Card render helper
const renderDibujoCard = (image) => (
  <div key={image.id} className="dibujo-image-wrapper">
    <img
      src={image.src}
      alt={image.alt}
      className="dibujo-image"
    />
  </div>
);

const renderImageCard = (image) => (
  <div key={image.id} className="character-image-wrapper">
    <img 
      src={image.src} 
      alt={image.alt} 
      className="character-image" 
    />
    <a 
      href={image.src} 
      download 
      className="btn-comic btn-comic-primary character-download-btn"
    >
      <i className="fa-solid fa-download me-1"></i>
      Descargar
    </a>
  </div>
);

// Character Gallery Component
const CharacterGallery = () => {
  return (
    <>
      {/* Bloque de dibujos */}
      <section className="mb-5">
        <h2>Integrantes de los Súper Agentes</h2>

        <div className="row justify-content-center">
          <div className="col-12">
            <div className="character-gallery">
              {dibujoImages.map(renderDibujoCard)}
            </div>
          </div>
        </div>
      </section>

      {/* Bloque de personajes */}
      <section className="mt-5">
        {/* <h2>Dibujos y Juegos</h2> */}

        <div className="gallery-block">
            <h3>Dibuja con los Súper Agentes</h3>
            <div className="character-gallery">
              {characterImages.slice(0, 4).map(renderImageCard)}
            </div>
          </div>

          <div className="gallery-block">
            <h3>Juegos</h3>
            <div className="character-gallery">
              {characterImages.slice(4, 9).map(renderImageCard)}
            </div>
          </div>
      </section>
    </>
  );
};


// Hero Section Component
const HeroSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const nextSlide = useCallback(() => {
    setActiveSlide((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="hero-section">
      <div className="container">

        {/* Character Gallery - Above the hero text */}
        <CharacterGallery />

        {/* Text Content */}
        <div className="row justify-content-center">
          <div className="col-lg-8 hero-text-col">
            <div className="pow-badge d-none d-lg-flex">
              <span>POW!</span>
            </div>
            <h1 className="hero-title">
              ¡Únete a la <br /><span className="text-blue">Misión!</span>
            </h1>
            <p className="hero-subtitle">
              Conviértete en un Súper Agente de la Legalidad y haz del mundo un lugar mejor.
            </p>

          </div>
        </div>

        {/* Carousel - Below the button */}
        <div className="row justify-content-center mt-4">
          <div className="col-lg-10">
            <div className="hero-carousel-frame">
              <div className="hero-carousel">
                {heroSlides.map((slide, index) => (
                  <div
                    key={index}
                    className={`hero-slide ${index === activeSlide ? 'active' : ''}`}
                  >
                    <img src={slide.image} alt="Hero" className="hero-slide-image" />
                    <div className="hero-slide-content">
                      <h3>{slide.title}</h3>
                      <p>{slide.subtitle}</p>
                    </div>
                  </div>
                ))}

                {/* Navigation Arrows */}
                <button className="carousel-arrow carousel-arrow-left" onClick={prevSlide} aria-label="Anterior">
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button className="carousel-arrow carousel-arrow-right" onClick={nextSlide} aria-label="Siguiente">
                  <i className="fa-solid fa-chevron-right"></i>
                </button>

                {/* Pagination Dots */}
                <div className="carousel-dots">
                  {heroSlides.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveSlide(index)}
                      className={`carousel-dot ${index === activeSlide ? 'active' : ''}`}
                      aria-label={`Ir a diapositiva ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
              {/* Decorative corners */}
              <div className="corner-dot top-left"></div>
              <div className="corner-dot top-right"></div>
              <div className="corner-dot bottom-left"></div>
              <div className="corner-dot bottom-right"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Team Section Component
const TeamSection = () => {
  const [activeVideo, setActiveVideo] = useState(0);

  const nextVideo = () => {
    setActiveVideo((prev) => (prev + 1) % teamVideos.length);
  };

  const prevVideo = () => {
    setActiveVideo(
      (prev) => (prev - 1 + teamVideos.length) % teamVideos.length
    );
  };

  return (
    <section id="agentes" className="team-section">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">EL EQUIPO</span>
          <h2 className="section-title-comic">
            Conoce a los Súper Agentes
          </h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="video-container-wrapper">

              <div className="video-frame">

                <video
                  key={activeVideo}
                  controls
                  playsInline
                  className="agent-video"
                >
                  <source
                    src={teamVideos[activeVideo].src}
                    type="video/mp4"
                  />
                </video>

                <button
                  className="carousel-arrow carousel-arrow-left"
                  onClick={prevVideo}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>

                <button
                  className="carousel-arrow carousel-arrow-right"
                  onClick={nextVideo}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>

                <div className="carousel-dots">
                  {teamVideos.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveVideo(index)}
                      className={`carousel-dot ${
                        activeVideo === index ? "active" : ""
                      }`}
                    />
                  ))}
                </div>

              </div>

              <div className="corner-dot top-left"></div>
              <div className="corner-dot top-right"></div>
              <div className="corner-dot bottom-left"></div>
              <div className="corner-dot bottom-right"></div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Values data
const valuesData = [
{
    id: 1,
    image: "/videos/fotos-agentes/gobernador.jpg",
    // comicEffect: "ZAP!",
    // effectClass: "zap",
    // frameClass: "frame-red",
    // titleClass: "text-red",
    // title: "Súper Honestidad en Acción",
    // text: "¡Hola! Nosotros somos los Súper Agentes de la Legalidad. Y estamos aquí para ayudar a que las niñas, niños y adolescentes de Hidalgo crezcan con valores fuertes. SÚPER HONESTA",
    layout: "left"
  },
  {
    id: 2,
    image: "/videos/fotos-agentes/secretario.jpg",
    // comicEffect: "BOOM!",
    // effectClass: "boom",
    // frameClass: "frame-blue",
    // titleClass: "text-blue",
    // title: "Nuestra Misión Principal",
    // text: "Nuestra misión es despertar su curiosidad y motivar su participación en actividades divertidas que enseñan la importancia de los valores y la legalidad. SÚPER RESPONSABLE",
    layout: "right"
  },
  {
    id: 3,
    image: "/videos/fotos-agentes/honesta.jpg",
    // comicEffect: "POW!",
    // effectClass: "pow",
    // frameClass: "frame-yellow",
    // titleClass: "text-yellow",
    // title: "Construyendo un Futuro Mejor",
    // text: "Promovemos los derechos de niñas, niños y adolescentes en todo el estado. Se destaca el esfuerzo, diálogo, transparencia y honestidad como claves para alcanzar sus metas. ¡Juntos construimos un futuro mejor!",
    layout: "left"
  }
];

// Value Panel Component
const ValuePanel = ({ item, index }) => {
  const rowClass = item.layout === "right" ? "flex-md-row-reverse" : "";
  const bubbleClass = item.layout === "right" ? "right" : "left";

  return (
    <div className="value-panel">
      <div className={`row align-items-center ${rowClass}`}>
        <div className="col-md-4">
          <div className="value-image-wrapper">
            <div className={`comic-effect ${item.effectClass}`}>{item.comicEffect}</div>
            <div className={`value-image-frame ${item.frameClass}`}>
              <img src={item.image} alt={`Valor ${index + 1}`} />
            </div>
          </div>
        </div>
        <div className="col-md-8">
          <div className={`speech-bubble ${bubbleClass}`}>
            <h3 className={`value-title ${item.titleClass}`}>{item.title}</h3>
            <p className="value-text">{item.text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Values Section Component
// const ValuesSection = () => {
//   return (
//     <section id="valores" className="values-section">
//       <div className="container">
//         <h2 className="section-title-values">Aprende con los Héroes</h2>

//         {valuesData.map((item, index) => (
//           <ValuePanel key={item.id} item={item} index={index} />
//         ))}
//       </div>
//     </section>
//   );
// };


const ValuesSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % valuesData.length);
  };

  const prevSlide = () => {
    setActiveSlide(
      (prev) => (prev - 1 + valuesData.length) % valuesData.length
    );
  };

  return (
    <section id="valores" className="values-section">
      <div className="container">

        <div className="values-carousel">

          {valuesData.map((item, index) => (
            <div
              key={item.id}
              className={`value-slide ${
                index === activeSlide ? "active" : ""
              }`}
              style={{
                backgroundImage: `url(${item.image})`
              }}
            >
              <div className="value-overlay">

                {/* <div className="pow-bubble">
                  {item.comicEffect}
                </div> */}

                {/* <h2>{item.title}</h2> */}

                {/* <div className="value-message">
                  <p>{item.text}</p>
                </div> */}

              </div>
            </div>
          ))}

          <button
            className="carousel-arrow carousel-arrow-left"
            onClick={prevSlide}
          >
            <i className="fa-solid fa-chevron-left"></i>
          </button>

          <button
            className="carousel-arrow carousel-arrow-right"
            onClick={nextSlide}
          >
            <i className="fa-solid fa-chevron-right"></i>
          </button>

          <div className="carousel-dots">
            {valuesData.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveSlide(index)}
                className={`carousel-dot ${
                  index === activeSlide ? "active" : ""
                }`}
              />
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

// Downloads Section Component
const DownloadsSection = () => {
  return (
    <section id="actividades" className="downloads-section">
      <div className="container">
        <h2 className="section-title-downloads">¡Zona de Entrenamiento!</h2>
        <div className="row">
          {downloads.map((item) => (
            <div key={item.id} className="col-md-4 mb-4">
              <DownloadCard item={item} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Main SuperAgentes Component
const SuperAgentes = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />

      {/* Main Content */}
      <main className="super-main">
        <HeroSection />
        <TeamSection />
        <ValuesSection />
      </main>


      {/* Latest News Section */}
      {/* <div id="noticias" className="container">
        <UltimasNoticias />
      </div> */}
    </>
  );
};

export default SuperAgentes;